import { type ErrorResponse, type ErrorOrigin, getErrorCode } from './apiUtils';
import { isApiError, type ApiError } from './baseQuery';

export const toErrorResponse = (error: ApiError): ErrorResponse => ({
    status: error.status,
    detail: error.detail,
});

export const getApiErrorCode = (error: ApiError, origin: ErrorOrigin) => getErrorCode(toErrorResponse(error), origin);

export const isApiErrorWithCode = (error: object | null | undefined): error is ApiError => isApiError(error);
